export const RESULT = {
  DONE_OVERDUE: 'done_overdue',
  DONE_ON_TIME: 'done_on_time',
  IN_PROGRESS: 'in_progress',
  IN_PROGRESS_OVERDUE: 'in_progress_overdue',
  IN_PROGRESS_UPCOMING: 'in_progress_upcoming',
  IN_PROGRESS_PLANNED: 'in_progress_planned',
  NOT_START_NO_PLANNED: 'not_start_no_planned',
}
